import { render, staticRenderFns } from "./EditorPicker.vue?vue&type=template&id=e4ed675e&"
import script from "./EditorPicker.vue?vue&type=script&lang=js&"
export * from "./EditorPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports